function getWindowWidth(): number {
  return window.innerWidth;
}

export default getWindowWidth;
